import {
  Accordion,
  AccordionPanel,
  Button,
  SidePanel,
  Skeleton,
  Container,
  Tooltip,
  ActionButton,
  Text,
  Icon,
  Notifications,
} from "@jds/core";
import React, { useState, useEffect, useCallback } from "react";
import { Link, NavLink, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import useApiHttp from "../../../hooks/use-http";
import { setSidebarDetails } from "../../../store/state-slices/eventDetails";

import classes from "./Sidepanel.module.css";
import "./Sidepanel_new.css";
import SideDrawer from "../../UI/SideDrawer/SideDrawer";
import { IconButton } from "@mui/material";

function Sidepanel_new(props) {
  const [open, setOpen] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id: eventId } = useParams();
  const { eventDetails } = useSelector((state) => state.eventDetails);
  const { sendRequest: getEventDetails, isLoading } = useApiHttp();

  const isAdmin = eventDetails?.userRole == "ADMIN";
  const isPhotographer = eventDetails?.userRole == "PHOTOGRAPHER";

  const loginDetails = useSelector((state) => state.auth.loginDetails);
  const isJitoUser = loginDetails?.userType === "JITO";
  const handleNavigateHome = useCallback(() => {
    navigate("/home", { state: { photographerTab: isPhotographer } });
  }, [isPhotographer]);
  const sideNavIcons = [
    "IcBurgerMenu",
    "IcHome",
    "IcCelebration",
    "IcGroup",
    "IcPhoto",
    "IcShare",
    "IcSettings",
    "IcAnalyticsPieChart",
  ];

  const navclickHandler = () => {
    props.mobileView && props.setOpen(false);
  };
  useEffect(() => {
    getEventDetails(
      {
        url: `event/get-event/${eventId}`,
        method: "GET",
      },
      null,
      (data) => {
        dispatch(setSidebarDetails({ eventDetails: data?.data }));
      },
      (err, data) => {
        if (data?.statusCode == 403) {
          navigate("/home");
          Notifications.toast.error({
            id: "get-folder",
            title: data?.message,
          });
        } else {
          Notifications.toast.error({
            id: "get-folder",
            title: data?.message,
          });
        }
      },
    );
  }, [eventId]);
  const toggle = () => {
    setOpen(!open);
  };

  return (
    <div
      style={{
        paddingTop: "110px",
        padding: "110px 20px",
        height: "100dvh",
        boxShadow: "0 4px 16px 0 rgba(0, 0, 0, 0.08)",
      }}>
      <div className="sidenav-closed">
        {sideNavIcons.map((value, index) => {
          return (
            <IconButton key={index} onClick={() => props.setOpen(true)}>
              <Icon ic={value} kind="background" size="large" />
            </IconButton>
          );
        })}
      </div>
      <SideDrawer isOpen={props.open}>
        <Container
          width="264px"
          style={{
            boxShadow: "var(--box-shadow-card)",
            padding: "32px 24px",
            // height: "calc(100vh - 80.95px)",
            height: "calc(100vh - 80px)",
            position: "sticky",
            top: "72px",
            marginTop: "72px",
          }}
          overflow="auto"
          direction="column"
          gap={16}>
          <Container
            style={{ padding: "20px 0px" }}
            fullWidth
            direction="row"
            verticalAlign="center">
            {!isJitoUser && (
              <>
                <Icon
                  ic={"IcBurgerMenu"}
                  onClick={() => {
                    props.setOpen(false);
                  }}
                  className="burgerclass"
                />
                <Tooltip label="Home" position="bottom">
                  <ActionButton
                    icon={"IcHome"}
                    onClick={handleNavigateHome}
                    size="small"
                  />
                </Tooltip>
              </>
            )}
            {isLoading ? (
              <Skeleton
                variant="text"
                sx={{ fontSize: "1rem", width: "100%" }}
              />
            ) : (
              <Tooltip label={eventDetails?.name} position="bottom">
                <Text
                  text={eventDetails?.name}
                  appearance="body-m-bold"
                  maxLines={2}
                />
              </Tooltip>
            )}
          </Container>
          <ul className={classes["nav__list"]}>
            {!isJitoUser && (
              <li className={classes["nav__item"]}>
                <NavLink
                  onClick={() => {
                    navclickHandler();
                  }}
                  className={classes["nav__link"]}
                  to={`/home/events/event-detail/${eventId}`}
                  style={({ isActive }) => {
                    return {
                      backgroundColor: isActive
                        ? "var(--color-primary-20)"
                        : "",
                    };
                  }}>
                  <Icon ic={"IcCelebration"} kind="background" size="large" />
                  <Text text="Events" appearance="" color="primary_grey_80" />
                </NavLink>
              </li>
            )}
            {/* <li className={classes["nav__item"]}>
                  <NavLink
                    className={classes["nav__link"]}
                    to={`/home/events/guests/${eventId}`}
                    style={({ isActive }) => {
                      return {
                        backgroundColor: isActive ? "var(--color-primary-20)" : "",
                      };
                    }}
                  >
                    <Icon ic={"IcGroup"} kind="background" size="large" />
        
                    <Text text="Guests" appearance="" color="primary_grey_80" />
                  </NavLink>
                </li> */}
            {isPhotographer && (
              <li className={classes["nav__item"]}>
                <NavLink
                  className={classes["nav__link"]}
                  to={`/home/events/albums/${eventId}`}
                  onClick={() => {
                    navclickHandler();
                  }}
                  style={({ isActive }) => {
                    return {
                      backgroundColor: isActive
                        ? "var(--color-primary-20)"
                        : "",
                    };
                  }}>
                  <Icon ic={"IcPhoto"} kind="background" size="large" />
                  <Text text="Albums" appearance="" color="primary_grey_80" />
                </NavLink>
              </li>
            )}

            {isAdmin && (
              <>
                <li
                  className={`${classes["nav__item"]} ${classes["nav__item--accordion"]}`}>
                  <Accordion expanded={[0]}>
                    <AccordionPanel
                      title="Users"
                      prefix={
                        <Icon ic={"IcGroup"} kind="background" size="large" />
                      }
                      showDivider={false}>
                      <Container direction="column" gap={8} flex={1}>
                        {!isJitoUser && (
                          <NavLink
                            className={classes["nav__link"]}
                            to={`/home/events/guests/${eventId}`}
                            onClick={() => {
                              navclickHandler();
                            }}
                            style={({ isActive }) => {
                              return {
                                backgroundColor: isActive
                                  ? "var(--color-primary-20)"
                                  : "",
                              };
                            }}>
                            <Text
                              text="Guests"
                              appearance=""
                              color="primary_grey_80"
                            />
                          </NavLink>
                        )}
                        <NavLink
                          className={classes["nav__link"]}
                          to={`/home/events/photographers/${eventId}`}
                          onClick={() => {
                            navclickHandler();
                            navclickHandler();
                          }}
                          style={({ isActive }) => {
                            return {
                              backgroundColor: isActive
                                ? "var(--color-primary-20)"
                                : "",
                            };
                          }}>
                          <Text
                            text="Photographers"
                            appearance=""
                            color="primary_grey_80"
                          />
                        </NavLink>
                      </Container>
                    </AccordionPanel>
                  </Accordion>
                </li>

                <li
                  className={`${classes["nav__item"]} ${classes["nav__item--accordion"]}`}>
                  <Accordion expanded={[0]}>
                    <AccordionPanel
                      title="Photos"
                      prefix={
                        <Icon ic={"IcPhoto"} kind="background" size="large" />
                      }
                      showDivider={false}>
                      <Container direction="column" gap={8} flex={1}>
                        <NavLink
                          className={classes["nav__link"]}
                          to={`/home/events/albums/${eventId}`}
                          onClick={() => {
                            navclickHandler();
                          }}
                          style={({ isActive }) => {
                            return {
                              backgroundColor: isActive
                                ? "var(--color-primary-20)"
                                : "",
                            };
                          }}>
                          <Text
                            text="Albums"
                            appearance=""
                            color="primary_grey_80"
                          />
                        </NavLink>
                        <NavLink
                          className={classes["nav__link"]}
                          to={`/home/events/faces/${eventId}`}
                          onClick={() => {
                            navclickHandler();
                          }}
                          style={({ isActive }) => {
                            return {
                              backgroundColor: isActive
                                ? "var(--color-primary-20)"
                                : "",
                            };
                          }}>
                          <Text
                            text="Faces"
                            appearance=""
                            color="primary_grey_80"
                          />
                        </NavLink>
                      </Container>
                    </AccordionPanel>
                  </Accordion>
                </li>

                {/* <li className={classes["nav__item"]}>
                      <NavLink
                        className={classes["nav__link"]}
                        to={`/home/events/qr/${eventId}`}
                        style={({ isActive }) => {
                          return {
                            backgroundColor: isActive ? "var(--color-primary-20)" : "",
                          };
                        }}
                      >
                        <Icon ic={"IcQrCode"} kind="background" size="large" />
                        <Text
                          text="Generate QR Code"
                          appearance=""
                          color="primary_grey_80"
                        />
                      </NavLink>
                    </li> */}
                {!isJitoUser && (
                  <li className={classes["nav__item"]}>
                    <NavLink
                      className={classes["nav__link"]}
                      to={`/home/events/share/${eventId}`}
                      onClick={() => {
                        navclickHandler();
                      }}
                      style={({ isActive }) => {
                        return {
                          backgroundColor: isActive
                            ? "var(--color-primary-20)"
                            : "",
                        };
                      }}>
                      <Icon ic={"IcShare"} kind="background" size="large" />

                      <Text
                        text="Share photos"
                        appearance=""
                        color="primary_grey_80"
                      />
                    </NavLink>
                  </li>
                )}
                {isAdmin && (
                  <li className={classes["nav__item"]}>
                    <NavLink
                      className={classes["nav__link"]}
                      to={`/home/events/settings/${eventId}`}
                      onClick={() => {
                        navclickHandler();
                      }}
                      style={({ isActive }) => {
                        return {
                          backgroundColor: isActive
                            ? "var(--color-primary-20)"
                            : "",
                        };
                      }}>
                      <Icon ic={"IcSettings"} kind="background" size="large" />

                      <Text
                        text="Settings"
                        appearance=""
                        color="primary_grey_80"
                      />
                    </NavLink>
                  </li>
                )}
                {!isJitoUser && (
                  <li className={classes["nav__item"]}>
                    <NavLink
                      className={classes["nav__link"]}
                      to={`/home/events/analytics/${eventId}`}
                      onClick={() => {
                        navclickHandler();
                      }}
                      style={({ isActive }) => {
                        return {
                          backgroundColor: isActive
                            ? "var(--color-primary-20)"
                            : "",
                        };
                      }}>
                      <Icon
                        ic={"IcAnalyticsPieChart"}
                        kind="background"
                        size="large"
                      />

                      <Text
                        text="Analytics"
                        appearance=""
                        color="primary_grey_80"
                      />
                    </NavLink>
                  </li>
                )}
              </>
            )}
          </ul>
        </Container>
      </SideDrawer>
    </div>
  );
}

export default Sidepanel_new;
